// NOVOLD PDP Sticky CTA — Phase 1.5
// - CTAクリック → main BUY area scrollIntoView
// - 購入モード（onetime/subscription）を
//   blocks/purchase-options.liquid のラジオから購読してバッジに反映（定期は1か月ごと固定）

(function () {
  "use strict";

  function findMainBuyTarget(anchor) {
    if (anchor) {
      try {
        const el = document.querySelector(anchor);
        if (el) return el;
      } catch (_) { /* invalid selector */ }
    }
    return (
      document.querySelector('purchase-options-component') ||
      document.querySelector('product-form-component') ||
      document.querySelector('[data-purchase-options]') ||
      document.querySelector('main form[action*="/cart/add"]') ||
      null
    );
  }

  function scrollTo(target) {
    if (!target) {
      console.warn('[pdp-sticky-cta] main BUY target not found');
      return;
    }
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const focusable = target.querySelector('input:not([type="hidden"]):not([disabled]), button:not([disabled])');
    if (focusable) {
      setTimeout(() => focusable.focus({ preventScroll: true }), 400);
    }
  }

  // 現在の購入モードを取得（お届けペースUIは廃止済み・定期=1か月ごと固定のため freq は扱わない）
  function readPurchaseState() {
    const purchaseRadio = document.querySelector('[data-purchase-radio]:checked');
    const mode = purchaseRadio ? purchaseRadio.value : 'onetime'; // 定期UI非表示時は単発扱い

    return { mode };
  }

  function applyState(root, state) {
    // data-stcta-save-badge は実額と乖離する「-10%」固定表示だったため撤去済み（no-op化）。
    // variant切替時にsticky barがmorphされてもこのスクリプトは再計算のフックを持たず、
    // 実額表示に切り替えても古い金額が残留する恐れがあり確実性に欠けるため表示自体をやめた。
    const modeBadges = root.querySelectorAll('[data-stcta-mode-badge]');

    if (state.mode === 'onetime') {
      modeBadges.forEach(b => {
        b.textContent = '単発購入';
        b.setAttribute('data-mode', 'onetime');
      });
    } else {
      modeBadges.forEach(b => {
        b.textContent = '定期 1か月ごと';
        b.setAttribute('data-mode', 'subscription');
      });
    }
  }

  function bindPurchaseObserver(root) {
    const update = () => applyState(root, readPurchaseState());

    // 初回反映（DOM が後から組まれる可能性も考慮）
    update();

    // ラジオの change を監視
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('[data-purchase-radio]')) {
        update();
      }
    });

    // purchase-options-component が遅延描画される場合の遅延再判定
    setTimeout(update, 250);
    setTimeout(update, 1000);
  }

  function init(root) {
    const anchor = root.dataset.mainBuyAnchor || '';

    root.querySelectorAll('[data-stcta-cart], [data-stcta-buy]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = findMainBuyTarget(anchor);
        scrollTo(target);
      });
    });

    root.querySelectorAll('[data-stcta-fav]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        // TODO: wishlist app 導入時に実装
      });
    });

    bindPurchaseObserver(root);
  }

  function boot() {
    document.querySelectorAll('[data-pdp-sticky-cta]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
